// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2VHwY","icon":"SortAdornment_icon__3rl7-","up":"SortAdornment_up__3x_7V","down":"SortAdornment_down__2ZBm1","active":"SortAdornment_active__9Krfc"};